import { logout } from "@/api/auth";
import { useAuth } from "@/hooks/useAuth";
import { ShieldCheck, SignOut } from "@phosphor-icons/react";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";

export function AdminLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const auth = useAuth();
  const isLoginPage = location.pathname === "/admin-login";

  const handleSignOut = async () => {
    await logout();
    await auth.refresh();
    navigate("/admin-login");
  };

  return (
    <div className="flex min-h-screen flex-col bg-[#0a0c10] text-text-primary">
      {/* Minimal admin header */}
      <header className="sticky top-0 z-50 flex h-12 items-center justify-between border-b border-white/10 bg-[#0f1117]/95 backdrop-blur-sm px-6">
        <Link
          to="/open-admin"
          className="flex items-center gap-2 text-sm font-semibold text-red-400 hover:text-red-300 transition-colors"
        >
          <ShieldCheck size={18} weight="bold" />
          <span>KuberCoin Admin</span>
        </Link>
        {!isLoginPage && (
          <button
            onClick={handleSignOut}
            className="flex items-center gap-1.5 text-xs text-text-muted hover:text-white transition-colors"
          >
            <SignOut size={14} />
            Sign out
          </button>
        )}
      </header>

      {/* Page content */}
      <main id="main" className="flex-1">
        <Outlet />
      </main>
    </div>
  );
}
